import React from "react";
import Topbar from "../Topbar/Topbar";
import { Container, Row, Col } from "react-bootstrap";
import "./Task.css";
import { useNavigate } from "react-router-dom";
import { HiPencil } from "react-icons/hi2";
import { MdDelete } from "react-icons/md";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Map from "../images/mapicon.svg";

import { Card, Badge, Image } from "react-bootstrap";
import "./TaskCard.css";
import { TbNumber } from "react-icons/tb";
import { useSelector } from "react-redux";
const isLocalhost = window.location.hostname === "localhost";
export const apiUrlImage = isLocalhost
  ? "http://localhost:3001/public/" // Local image path
  : "https://help-desk-backend-d3kq.onrender.com/Router/service/public/images/";

export default function Task() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const permissions = useSelector((state) => state.permissions); // Adjust based on your reducer path
  const [staffData, setstaffData] = useState([]);
  const role = useSelector((state) => state.roleName);
  const userId = useSelector((state) => state.id);

  console.log(userId, "userid");

  console.log(role);
  //pending approvals
  const [showPendingApprovalCanvas, setShowPendingApprovalCanvas] =
    useState(false);
  const [filteredPendingApprovals, setFilteredPendingApprovals] = useState([]);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState({});
  const [openApprovalPopup, setOpenApprovalPopup] = useState(null);
  // Toggle
  const toggleApprovalDescription = (idx) => {
    setIsDescriptionExpanded((prev) => ({ ...prev, [idx]: !prev[idx] }));
  };

  const toggleApprovalPopup = (taskId) => {
    setOpenApprovalPopup(openApprovalPopup === taskId ? null : taskId);
  };

  const closeApprovalPopup = () => {
    setOpenApprovalPopup(null);
  };

  const handleOpenApprovalCanvas = () => {
    setShowPendingApprovalCanvas(true);
  };

  const handleCloseApprovalCanvas = () => {
    setShowPendingApprovalCanvas(false);
  };
  //end
  const [taskDetails, settaskDetails] = useState([]);
  const gotomyTask = () => {
    navigate("/mytask");
  };

  const gotoEditTask = (id) => {
    navigate("/edittask", {
      state: { id: id },
    });
  };

  const gotomyTask1 = () => {
    navigate("/task");
  };

  // const getCardBgColor = (status) => {
  //   switch (status?.toLowerCase()) {
  //     case "open":
  //       return "bg-sand";
  //     case "progress":
  //       return "bg-lightgrey";
  //     case "completed":
  //       return "bg-lightgreen";
  //     case "hold":
  //       return "bg-mildorange";
  //     default:
  //       return "";
  //   }
  // };

  const getCardBgColor = (status, approveStatus) => {
    const lowerStatus = status?.toLowerCase();
    const lowerApprove = approveStatus?.toLowerCase();

    if (lowerStatus === "completed") {
      if (lowerApprove === "pending") return "bg-redcolor";
      if (lowerApprove === "approved") return "bg-lightgreen";
      if (lowerApprove === "resubmit") return "bg-redcolor";

      return "";
    }

    switch (lowerStatus) {
      case "open":
        return "bg-sand";
      case "progress":
        return "bg-lightgrey";
      case "hold":
        return "mild-orange";
      default:
        return "";
    }
  };

  const getTaskTypeColor = (taskName) => {
    switch (taskName?.toLowerCase()) {
      case "enquiry":
        return "bg-purple"; // custom
      case "installation":
        return "bg-success"; // Bootstrap green
      case "recovery":
        return "bg-brown"; // custom
      case "compliant":
        return "bg-darkred";
      // custom
      default:
        return "bg-primary";
    }
  };

  // const openTasks = taskDetails?.filter(task =>
  //   ["open", "progress"].includes(task.taskStatus?.toLowerCase())
  // );

  // const completedTasks = taskDetails.filter(task =>
  //   task.taskStatus?.toLowerCase() === "completed"
  // );

  const [expandedIndexes, setExpandedIndexes] = useState({});

  const toggleDescription = (index) => {
    setExpandedIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "open":
        return "bg-yellow-status";
      case "progress":
        return "bg-grey-status";
      case "completed":
        return "bg-green-status";
      case "hold":
        return "bg-orange-status";
      default:
        return "";
    }
  };

  function parseDateTime(dateStr, timeStr) {
    const [time, modifier] = timeStr?.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    const date = new Date(dateStr);
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  }

  const filteredTasks = Array.isArray(taskDetails)
    ? taskDetails.filter((task) => {
        const status = task.taskStatus?.toLowerCase();
        const deadlineDateTime = new Date(task.deadline);

        return (
          ["open", "progress", "hold"].includes(status) &&
          deadlineDateTime < new Date()
        );
      })
    : [];

  const today = new Date();
  today.setHours(0, 0, 0, 0); // Clear time for comparison

  const filteredTasksOpen = Array.isArray(taskDetails)
    ? taskDetails.filter((task) => {
        const status = task.taskStatus?.toLowerCase();

        const assignDate = new Date(task.assignDateTime);
        assignDate.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const isAssignedToday = assignDate.getTime() === today.getTime();

        const deadlineDateTime = new Date(task.deadline);
        const isDeadlineInFuture = deadlineDateTime > new Date();

        return (
          ["open", "progress", "hold"].includes(status) &&
          isAssignedToday &&
          isDeadlineInFuture
        );
      })
    : [];

  console.log(filteredTasksOpen, "openData");

  // remove time from today

  const filteredTasksUpcoming = Array.isArray(taskDetails)
    ? taskDetails.filter((task) => {
        const status = task.taskStatus?.toLowerCase();
        const assignDateTime = new Date(task.assignDateTime);
        return status === "open" && assignDateTime > new Date();
      })
    : [];

  console.log(filteredTasksUpcoming);

  // useEffect(() => {
  //   axios.post(apiUrl + "getdata-enquirytask", {})
  //     .then((res) => {
  //       const add_installation = res.data.message || [];
  //       console.log("Fetched taskDetails:", add_installation);

  //       // Reverse the array to get descending order (latest first)
  //       const reversedTasks = add_installation.slice().reverse();

  //       settaskDetails(reversedTasks);
  //     })
  //     .catch(err => {
  //       console.error("Error fetching tasks:", err);
  //     });
  // }, []);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        let response;

        if (role === "Super Admin") {
          response = await axios.post(apiUrl + "getdata-enquirytask");
        } else {
          response = await axios.post(apiUrl + "view-task-by-assignedto", {
            staffId: userId,
          });
        }

        let allTasks = [];

        if (role === "Super Admin") {
          // If super admin, get tasks from `message`
          allTasks = Array.isArray(response.data.message)
            ? response.data.message
            : [];
        } else {
          // For others, get tasks from `data`
          allTasks = Array.isArray(response.data.data)
            ? response.data.data
            : [];
        }

        const sortedData = [...allTasks].reverse();

        settaskDetails(sortedData); // ✅ Now it will set properly

        // Optional: filter for approved/completed
        const matchedTasks = sortedData.filter((task) => {
          const isApprovedByUser = task?.approvePerson?.some(
            (person) => person._id === userId
          );
          return (
            task.taskStatus === "Completed" &&
            task.approveStatus === "Pending" &&
            isApprovedByUser
          );
        });

        setFilteredPendingApprovals(matchedTasks);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    };

    fetchTasks();
  }, []);
  //fetch staff

  console.log(taskDetails, "taskData");

  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setstaffData(res.data.message);
      });
  }, [apiUrl]);

  console.log(taskDetails);

  const [tasks, setTasks] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [mergedData, setMergedData] = useState([]);

  //   useEffect(() => {
  //     const fetchData = async () => {
  //       try {
  //         const [taskRes, enquiryRes] = await Promise.all([
  //           axios.post("http://localhost:3001/api/view-task"),
  //           axios.post("http://localhost:3001/api/view-enquiry"),
  //         ]);

  //         // ✅ Log to confirm the structure
  //         console.log("Task Res:", taskRes.data);
  //         console.log("Enquiry Res:", enquiryRes.data);

  //         // ✅ Extract data safely
  //         const tasks = Array.isArray(taskRes.data) ? taskRes.data : taskRes.data.data || [];
  //         const enquiries = Array.isArray(enquiryRes.data) ? enquiryRes.data : enquiryRes.data.data || [];

  //         // ✅ Merge based on leadId
  //         const merged = tasks.map((task) => {
  //           const matchingEnquiry = enquiries.find(
  //             (enquiry) => enquiry.leadId === task.leadId
  //           );
  //           return {
  //             ...task,
  //             enquiryDetails: matchingEnquiry || {},
  //           };
  //         });
  // console.log(merged)
  //         setMergedData(merged);
  //         console.log("Merged Data:", merged);
  //       } catch (err) {
  //         console.error("Error fetching or merging data:", err);
  //       }
  //     };

  //     fetchData();
  //   }, []);

  const [statusCounts, setStatusCounts] = useState({
    open: 0,
    progreass: 0,
    cancelled: 0,
    completed: 0,
  });

  const [show, setShow] = useState(false);
  const [customerdelete, setCustomerdelete] = useState(false);
  const [data, setData] = useState([]);

  const handleShow = () => setShow((prev) => !prev);
  const handleClose = () => setShow(false);
  const [openPopup, setOpenPopup] = useState(null);

  const navigate = useNavigate();

  const gotoCreateTask = (e) => {
    e.preventDefault();
    navigate("/createtask");
  };

  const gotoMapView = (e) => {
    e.preventDefault();
    navigate("/taskmapview");
  };

  const gotoListView = (e) => {
    e.preventDefault();
    navigate("/tasklistview");
  };

  const [setting, setSetting] = useState(false);
  const settingPopupDots = (e) => {
    e.preventDefault();
    setSetting(!setting);
    setOpenPopup(null);
  };

  const [settingPopupDotsClose, setSettingPopupDotsClose] = useState(false);

  const togglePopup = (taskId) => {
    setOpenPopup(openPopup === taskId ? null : taskId);
  };

  const getPriorityClass = (priority) => {
    switch (priority?.toLowerCase()) {
      case "low":
        // return "badge-blue-task-page";
        return "badge-blue-task-page";
      case "high":
        return "bg-warning";

      case "immediate":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  // let route = "";

  // switch (taskName?.toLowerCase()) {
  //   case "enquiry":
  //     route = "/mytask";
  //     break;
  //   case "installation":
  //     route = "/installation-view";
  //     break;
  //   case "recovery":
  //     route = "/recovery-view";
  //     break;
  //   case "compliant":
  //     route = "/compliant-view";
  //     break;
  //   default:
  //     route = "/task-view";
  // }

  // // Pass leadId through navigation state
  // navigate(route, { state: { leadId } });

  // const handleCardClick = (_id,fromApprovePerson) => {
  //   navigate("/mytask", {
  //     state: { id: _id,
  //       // fromApprovePerson:
  //       // fromAssignPerson:
  //      },
  //   });
  // };

  const handleByPersonClick = (_id, approvePerson, assignedTo) => {
    const fromApprovePerson = approvePerson?.some(
      (person) => person._id === userId
    );
    const fromAssignPerson = assignedTo?.some(
      (person) => person._id === userId
    );

    navigate("/mytask", {
      state: {
        id: _id,
        fromApprovePerson,
        fromAssignPerson,
      },
    });
  };

  const handleCardClick = (_id, assignedTo) => {
    const fromAssignPerson = assignedTo?.some(
      (person) => person._id === userId
    );

    navigate("/mytask", {
      state: { id: _id, fromAssignPerson },
    });
  };

  const handleApproveClick = (_id, fromApprovePerson = true) => {
    navigate("/mytask", {
      state: {
        id: _id,
        fromApprovePerson: fromApprovePerson,
      },
    });
  };
  // const handleCardClick = (taskStatus, _id) => {
  //   if (taskStatus === "progress") {
  //     navigate("/view_createtask", {
  //       state: { id: _id },
  //     });
  //   } else {
  //     navigate("/mytask", {
  //       state: { id: _id },
  //     });
  //   }
  // };

  const filteredTasksLength = taskDetails.filter(
    (task) =>
      ["open", "progress", "hold"].includes(task.taskStatus?.toLowerCase()) &&
      new Date(task.deadline) < new Date(new Date().setHours(0, 0, 0, 0))
  ).length;

  const openAndFutureTasks = taskDetails.filter(
    (task) =>
      ["open", "progress", "hold"].includes(task.taskStatus?.toLowerCase()) &&
      new Date(task.deadline).setHours(0, 0, 0, 0) >=
        new Date().setHours(0, 0, 0, 0)
  );
  const filteredcompleted = taskDetails.filter((task) => {
    return (
      task.taskStatus?.toLowerCase() === "completed"
      // task.approveStatus?.toLowerCase() === "approved"
    );
  }).length;

  const taskData = [
    {
      id: 1,
      type: "Enquiry",
      typeClass: "purplebox",
      status: "Progress",
      statusClass: "progressbox",
      assignedBy: "Saravanan",
      priority: "Low",
      assignedTo: [1, 2, 3, 4],
      approvedBy: [5, 6],
      description:
        "Brainstorming brings team members' diverse experience into play.",
    },
    {
      id: 2,
      type: "Recovery",
      typeClass: "orangebox",
      status: "Open",
      statusClass: "openbox",
      assignedBy: "Saravanan",
      priority: "Low",
      assignedTo: [1, 2, 3, 4],
      approvedBy: [5, 6],
      description:
        "Brainstorming brings team members' diverse experience into play.",
    },
    {
      id: 3,
      type: "Installation",
      typeClass: "greenbox",
      status: "Open",
      statusClass: "openbox",

      assignedBy: "Saravanan",
      priority: "Low",
      assignedTo: [1, 2, 3, 4],
      approvedBy: [5, 6],
      description:
        "Brainstorming brings team members' diverse experience into play.",
    },
    {
      id: 4,
      type: "Due Collection",
      typeClass: "bluebox",
      status: "Open",
      statusClass: "openbox",
      assignedBy: "Saravanan",
      priority: "Low",
      assignedTo: [1, 2, 3, 4],
      approvedBy: [5, 6],
      description:
        "Brainstorming brings team members' diverse experience into play.",
    },
  ];

  const taskData_Upcomming = [
    {
      id: 1,
      type: "Enquiry",
      typeClass: "purplebox",
      status: "Open",
      assignedBy: "Saravanan",
      priority: "Low",
      assignedTo: [1, 2, 3, 4],
      approvedBy: [5, 6],
      description:
        "Brainstorming brings team members' diverse experience into play.",
    },
    {
      id: 2,
      type: "Recovery",
      typeClass: "orangebox",
      status: "Open",
      assignedBy: "Saravanan",
      priority: "Low",
      assignedTo: [1, 2, 3, 4],
      approvedBy: [5, 6],
      description:
        "Brainstorming brings team members' diverse experience into play.",
    },
    {
      id: 3,
      type: "Installation",
      typeClass: "greenbox",
      status: "Open",
      assignedBy: "Saravanan",
      priority: "Low",
      assignedTo: [1, 2, 3, 4],
      approvedBy: [5, 6],
      description:
        "Brainstorming brings team members' diverse experience into play.",
    },
    {
      id: 4,
      type: "Cash Collection",
      typeClass: "bluebox",
      status: "Open",
      assignedBy: "Saravanan",
      priority: "Low",
      assignedTo: [1, 2, 3, 4],
      approvedBy: [5, 6],
      description:
        "Brainstorming brings team members' diverse experience into play.",
    },
  ];

  const handleDelete = async (customerid) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.post("http://localhost:3001/api/delete", {
          customerid: customerid,
        });
        Swal.fire("Deleted!", "Your data has been deleted.", "success");
        setCustomerdelete(true);
      } catch (error) {
        Swal.fire("Error!", "Something went wrong while deleting.", "error");
        console.error("Delete Error:", error);
      }
    }
  };

  console.log("Approve Person Data:", taskDetails);

  return (
    <div className="customer-scroll-stop">
      <div className="container-fluid">
        <Topbar />
      </div>
      <Container fluid>
        <Row className="taskRow1">
          <Col>
            <h3 className="px-2">My Task</h3>
          </Col>
          <Col sm={10} className="taskRight">
            <button className="taskBtn text-white" onClick={gotoListView}>
              List View
            </button>

            <button
              className="taskBtn"
              onClick={handleShow}
              style={{ backgroundColor: "#CEA87A" }}
            >
              Upcoming Task
            </button>

            <Offcanvas
              show={show}
              onHide={handleClose}
              placement="end"
              backdrop={true}
            >
              <Offcanvas.Header closeButton className="mb-0 pb-0">
                <Offcanvas.Title>
                  <Row className="text-start">
                    <Col border className="d-flex flex-direction-column">
                      <div className="status-container">
                        <div className="status-item text-center">
                          <span className="dot orangebox"></span>
                          <span className="status-text">Upcomming</span>
                          <span className="status-count">
                            {filteredTasksUpcoming.length}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <div className="underlineTask_SB"></div>
              <Offcanvas.Body
                style={{
                  overflowY: "auto",
                  maxHeight: "100vh", // ensures full screen scroll
                  paddingBottom: "50px", // optional: gives space at bottom for last card visibility
                }}
                className="h-100 mt-0 border  "
              >
                {filteredTasksUpcoming.map((task, index) => (
                  //   <Card
                  //     key={ind1}
                  //     className={`task-card-box p-0 mx-auto ${getCardBgColor(task.taskStatus)}`}
                  //     style={{ backgroundColor: "", borderRadius: "20px" }}
                  //   >
                  //     <div className="mx-auto task-card-item">
                  //       <Row className="mb-2">
                  //         <Col className="pt-1">
                  //           <Badge
                  //             // bg={task.typeClass}
                  //             className={`task-enquiry  ${getTaskTypeColor(task.taskName)}`}
                  //             onClick={gotomyTask}
                  //             style={{width:"100px"}}
                  //           >
                  //             <p style={{fontSize:"12px",paddingTop:"4px"}}> {task.taskName}</p>
                  //           </Badge>
                  //         </Col>
                  //         <Col className="text-end mb-0 pb-0">
                  //           <Badge
                  // className={`progress-main  ${getTaskTypeColor(task.taskName)}`}
                  //             bg={task.statusClass1}
                  //             onClick={gotomyTask}

                  //             // style={{marginTop:"5px"}}
                  //           >
                  //             <p className={`progress-body pt-2 ${getStatusColor(task.taskStatus)}`}>{task.taskStatus}</p>
                  //           </Badge>
                  //         </Col>

                  //         <span
                  //           className="dots mt-2"
                  //           onClick={() => togglePopup(ind1)}
                  //         >
                  //           ...
                  //         </span>
                  //         {openPopup === ind1 && (
                  //           <div
                  //             className="task-popup-container p-0 m-0"
                  //             style={{
                  //               width: "150px",
                  //               position: "absolute",
                  //               right: "10px",
                  //               zIndex: 1000,
                  //               background: "white",
                  //               boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                  //               borderRadius: "10px",
                  //               padding: "8px",
                  //             }}
                  //           >
                  //             <button
                  //               className="task-close-btn"
                  //               onClick={() => togglePopup(ind1)}
                  //               style={{
                  //                 border: "none",
                  //                 background: "transparent",
                  //                 float: "right",
                  //                 fontSize: "20px",
                  //               }}
                  //             >
                  //               &times;
                  //             </button>
                  //             <div className="task-popup-content w-100 p-2">
                  //               <div className="row d-flex justify-content-center align-items-center">
                  //                 <div className="col-auto">
                  //                   <HiPencil size={20} />
                  //                   <br />
                  //                   <MdDelete size={20} className="text-danger" />
                  //                 </div>
                  //                 <div className="col text-start">
                  //                   <div>
                  //                     Edit
                  //                     <br />
                  //                     Delete
                  //                   </div>
                  //                 </div>
                  //               </div>
                  //             </div>
                  //           </div>
                  //         )}
                  //       </Row>

                  //       <Card.Text className="task-description">
                  //         {task.description}
                  //       </Card.Text>

                  //       <div>
                  //         <div className="d-flex justify-content-between align-items-center mb-5">
                  //           <p className="assignedBy">
                  //             <b>Assigned By:</b>{" "}
                  //             <span className="fw-bold text-black">
                  //               {task?.assignedBy?.staffName}
                  //             </span>
                  //           </p>
                  //           {/* <Badge bg="primary assignedBy">{task.taskPriority}</Badge> */}

                  // <span className={`assignedBy  taskpriority badge ${getPriorityClass(task.taskPriority)}`}>
                  //   {task.taskPriority}
                  // </span>
                  //         </div>

                  //         <div>
                  //           <p className="assignedBy">
                  //             <b>Assigned To:</b>
                  //             <div className="avatars mt-0">
                  //               {task.assignedTo.map((img, i) => (

                  //                 <p>{img.staffName}</p>
                  //                 // <Image
                  //                 //   key={i}
                  //                 //   src={`https://i.pravatar.cc/40?img=${img}`}
                  //                 //   roundedCircle
                  //                 //   className="avatar-img"
                  //                 // />
                  //               ))}
                  //             </div>
                  //           </p>

                  //           <p className="assignedBy text-end approvedBy pe-0">
                  //             <b>Approve Person:</b>
                  //             <div className="avatars1 text-end ps-2">
                  //               {task.approvePerson.map((num, j) => (
                  //                 // <Image
                  //                 //   key={j}
                  //                 //   src={`https://i.pravatar.cc/40?img=${num}`}
                  //                 //   roundedCircle
                  //                 //   className="avatar-img1"
                  //                 // />

                  //                 <p>{num.staffName}</p>
                  //               ))}
                  //             </div>
                  //           </p>
                  //         </div>
                  //       </div>
                  //     </div>
                  //   </Card>

                  <Card
                    key={index}
                    // onClick={() => handleCardClick( task._id)}

                    // className="task-card-box p-0 mx-auto"
                    className={`task-card-box p-0 mx-auto mt-5 ${getCardBgColor(
                      task.taskStatus,
                      task.approveStatus
                    )}`}
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="mx-auto task-card-item mt-2  ">
                      <Row className="mb-2 ">
                        <Col className="pt-1 ">
                          {/* <Badge
                      bg={task.typeClass}
                      className="task-recovery"
                      onClick={gotomyTask}
                    >
                      {task.taskName}
                    </Badge> */}

                          <Badge
                            bg="jkjf"
                            className={`task-recovery taskname-padding  ${getTaskTypeColor(
                              task.taskName
                            )}`}
                            // onClick={gotomyTask}
                          >
                            {task.taskName.length > 15
                              ? `${task.taskName.substring(0, 15)}...`
                              : task.taskName}
                          </Badge>
                        </Col>
                        <Col className="text-end mb-0 pb-0">
                          <Badge
                            className="progress-main"
                            bg="progressbox"
                            onClick={gotomyTask}
                          >
                            <p
                              className={`progress-body ${getStatusColor(
                                task.taskStatus
                              )}`}
                            >
                              {["Hold", "No Response"].includes(task.taskStatus)
                                ? "Hold"
                                : task.taskStatus}
                            </p>
                          </Badge>
                        </Col>

                        <span
                          className="dots mt-2"
                          onClick={() => {
                            togglePopup(task._id);
                          }}
                        >
                          ...
                        </span>

                        {openPopup === task._id && (
                          <div className="task-popup-container p-0 m-0">
                            <button
                              className="task-close-btn"
                              onClick={settingPopupDots}
                            >
                              &times;
                            </button>
                            <div className="task-popup-content w-100 p-1 ms-2">
                              <div className="row d-flex justify-content-center align-items-center w-75">
                                <div className="col pt-1">
                                  <HiPencil /> <br />
                                  <MdDelete />
                                </div>
                                <div className="col pt-1 text-start">
                                  Edit <br /> Delete
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </Row>

                      {/* <Card.Text className="task-description">
                  {task.description}
                </Card.Text> */}

                      <div>
                        <Card.Text
                          className={`task-description ${
                            !expandedIndexes[index] ? "line-clamp" : ""
                          }`}
                        >
                          {task.description || "No description"}
                        </Card.Text>

                        {task.description?.length > 100 && (
                          <span
                            onClick={() => toggleDescription(index)}
                            style={{
                              color: "blue",
                              cursor: "pointer",
                              fontWeight: "500",
                              paddingTop: "-80px",
                            }}
                          >
                            {expandedIndexes[index] ? "Show less" : "Read more"}
                          </span>
                        )}

                        <div>
                          <div className="d-flex justify-content-between align-items-center mb-5 mt-3">
                            <p className="assignedBy">
                              <b>
                                {" "}
                                Assigned By:{" "}
                                {task.assignedBy?.staffName || "N/A"}
                              </b>
                              {/* <div>
                                {staffData
                                  ?.filter(
                                    (staff) => staff._id === task.assignedBy?.id
                                  )
                                  .map((staff, i) => (
                                    <div
                                      key={`assignedBy-${i}`}
                                      style={{
                                        display: "inline-block",
                                        marginRight: "10px",
                                      }}
                                    >
                                      <Image
                                        src={
                                          staff?.staffPhoto?.fileName
                                            ? apiUrlImage +
                                              staff.staffPhoto.fileName
                                            : apiUrlImage + "default.jpg"
                                        }
                                        roundedCircle
                                        className="avatar-img"
                                      />
                                    </div>
                                  ))}
                              </div> */}
                            </p>
                            {/* <Badge className={`assignedBy ${getPriorityClass(task.taskPriority)}`}>
  {task.taskPriority}
</Badge> */}

                            <span
                              className={`assignedBy  taskpriority badge ${getPriorityClass(
                                task.taskPriority
                              )}`}
                            >
                              {task.taskPriority}
                            </span>
                          </div>

                          <div>
                            <p className="assignedTo">
                              <b>Assigned To:</b>
                              <div className="avatars mt-0">
                                {staffData
                                  ?.filter((staff) =>
                                    task.assignedTo?.some(
                                      (assigned) => assigned._id === staff._id
                                    )
                                  )
                                  .map((staff, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        display: "inline-block",
                                        marginRight: "10px",
                                      }}
                                    >
                                      <Image
                                        src={
                                          staff?.staffPhoto?.fileName
                                            ? apiUrlImage +
                                              staff.staffPhoto.fileName
                                            : apiUrlImage + "default.jpg"
                                        }
                                        roundedCircle
                                        className="avatar-img"
                                      />
                                    </div>
                                  ))}
                              </div>
                              <div>
                                <b style={{ fontSize: "12px" }}>
                                  <div className="mt-2">
                                    {task.assignedTo?.length > 0 ? (
                                      <ul className="ps-3 mb-0">
                                        {task.assignedTo.map(
                                          (person, index) => (
                                            <li
                                              key={index}
                                              style={{ fontSize: "14px" }}
                                            >
                                              {person.staffName}
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    ) : (
                                      <span style={{ fontSize: "14px" }}>
                                        No Approvers
                                      </span>
                                    )}
                                  </div>
                                </b>
                              </div>
                            </p>

                            <p className=" text-end approvedBy pe-0">
                              <b>Approve Person:</b>
                              <div className="avatars1 text-end ps-2  ">
                                {staffData
                                  ?.filter((staff) =>
                                    task.approvePerson?.some(
                                      (approver) => approver._id === staff._id
                                    )
                                  )
                                  .slice(0, 2) // show only first 3
                                  .map((staff, i) => (
                                    <div
                                      key={`approve-${i}`}
                                      style={{
                                        display: "inline-block",
                                        marginRight: "10px",
                                      }}
                                    >
                                      <Image
                                        src={
                                          staff?.staffPhoto?.fileName
                                            ? apiUrlImage +
                                              staff.staffPhoto.fileName
                                            : apiUrlImage + "default.jpg"
                                        }
                                        roundedCircle
                                        className="avatar-img"
                                      />
                                    </div>
                                  ))}

                                {/* Show "+N more" if count exceeds 3 */}
                                {task.approvePerson?.length > 2 && (
                                  <div
                                    style={{
                                      verticalAlign: "middle",
                                      background: "#ccc",
                                      borderRadius: "50%",
                                      width: "25px",
                                      height: "25px",
                                      textAlign: "center",
                                      lineHeight: "26px",
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    +{task.approvePerson.length - 2}
                                  </div>
                                )}
                              </div>
                              <div>
                                <b style={{ fontSize: "12px" }}>
                                  {task?.approvePerson?.length > 0 ? (
                                    <>
                                      {task.approvePerson
                                        .slice(0, 2) // Only first 2 names
                                        .map((person, index) => (
                                          <span key={index}>
                                            {person.staffName}
                                            {index <
                                            task.approvePerson.slice(0, 2)
                                              .length -
                                              1
                                              ? ", "
                                              : ""}
                                          </span>
                                        ))}
                                      {task.approvePerson.length > 2 && (
                                        <span>
                                          {" "}
                                          +{task.approvePerson.length - 2} more
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    "No Approvers"
                                  )}
                                </b>
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                ))}
              </Offcanvas.Body>
            </Offcanvas>

            <button
              className="taskBtn"
              onClick={handleOpenApprovalCanvas}
              style={{ backgroundColor: "#CEA87A" }}
            >
              Pending approvals{" "}
              {filteredPendingApprovals.length > 0 && (
                <span className="status-count-pa ms">
                  {filteredPendingApprovals.length}
                </span>
              )}
            </button>
            <Offcanvas
              show={showPendingApprovalCanvas}
              onHide={handleCloseApprovalCanvas}
              placement="end"
              className="rounded-start-5"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                  <h4>
                    <span className="dot orangebox"></span> Pending approvals
                  </h4>
                </Offcanvas.Title>
              </Offcanvas.Header>

              <div className="underlineTask_SB"></div>

              <Offcanvas.Body
                style={{
                  overflowY: "auto",
                  maxHeight: "100vh",
                  paddingBottom: "50px",
                }}
              >
                {filteredPendingApprovals.map((task, index) => (
                  <Card
                    key={task._id}
                    onClick={() => handleApproveClick(task._id, true)}
                    className={`task-card-box p-0 mx-auto mt-5 ${getCardBgColor(
                      task.taskStatus,
                      task.approveStatus
                    )}`}
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="mx-auto task-card-item mt-2">
                      <Row className="mb-2">
                        <Col className="pt-1">
                          <Badge
                            className={`task-recovery taskname-padding ${getTaskTypeColor(
                              task.taskName
                            )}`}
                          >
                            {task.taskName.length > 15
                              ? `${task.taskName.substring(0, 15)}...`
                              : task.taskName}
                          </Badge>
                        </Col>
                        <Col className="text-end">
                          <Badge className="progress-main" bg="progressbox">
                            <p
                              className={`progress-body ${getStatusColor(
                                task.taskStatus
                              )}`}
                            >
                              {["Hold", "No Response"].includes(task.taskStatus)
                                ? "Hold"
                                : task.taskStatus}
                            </p>
                          </Badge>
                        </Col>
                        {permissions?.Task?.["Edit Task"]?.Write && (
                          <>
                            <span
                              className="dots mt-2"
                              onClick={() => toggleApprovalPopup(task._id)}
                            >
                              ...
                            </span>

                            {openApprovalPopup === task._id && (
                              <div className="task-popup-container p-0 m-0">
                                <button
                                  className="task-close-btn"
                                  onClick={closeApprovalPopup}
                                >
                                  &times;
                                </button>
                                <div className="task-popup-content w-100 p-1 ms-2">
                                  <div className="row d-flex justify-content-center align-items-center w-75">
                                    <div className="col pt-1">
                                      <HiPencil /> <br /> <MdDelete />
                                    </div>
                                    <div className="col pt-1 text-start">
                                      Edit <br /> Delete
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </Row>

                      <Card.Text
                        className={`task-description ${
                          !isDescriptionExpanded[index] ? "line-clamp" : ""
                        }`}
                      >
                        {task.description || "No description"}
                      </Card.Text>

                      {task.description?.length > 100 && (
                        <span
                          onClick={() => toggleApprovalDescription(index)}
                          style={{
                            color: "blue",
                            cursor: "pointer",
                            fontWeight: "500",
                          }}
                        >
                          {isDescriptionExpanded[index]
                            ? "Show less"
                            : "Read more"}
                        </span>
                      )}

                      <div className="d-flex justify-content-between align-items-center my-3">
                        <p className="assignedBy">
                          <b>
                            {" "}
                            Assigned By: {task.assignedBy?.staffName || "N/A"}
                          </b>
                          {/* <div>
                            {staffData
                              ?.filter(
                                (staff) => staff._id === task.assignedBy?.id
                              )
                              .map((staff, i) => (
                                <div
                                  key={`assignedBy-${i}`}
                                  style={{
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                >
                                  <Image
                                    src={
                                      staff?.staffPhoto?.fileName
                                        ? apiUrlImage +
                                          staff.staffPhoto.fileName
                                        : apiUrlImage + "default.jpg"
                                    }
                                    roundedCircle
                                    className="avatar-img"
                                  />
                                </div>
                              ))}
                          </div> */}
                        </p>
                        <span
                          className={`assignedBy taskpriority badge ${getPriorityClass(
                            task.taskPriority
                          )}`}
                        >
                          {task.taskPriority}
                        </span>
                      </div>

                      <p className="assignedTo">
                        <b>Assigned To:</b>
                        <div className="avatars mt-0">
                          {staffData
                            ?.filter((staff) =>
                              task.assignedTo?.some(
                                (assigned) => assigned._id === staff._id
                              )
                            )
                            .map((staff, i) => (
                              <div
                                key={i}
                                style={{
                                  display: "inline-block",
                                  marginRight: "10px",
                                }}
                              >
                                <Image
                                  src={
                                    staff?.staffPhoto?.fileName
                                      ? apiUrlImage + staff.staffPhoto.fileName
                                      : apiUrlImage + "default.jpg"
                                  }
                                  roundedCircle
                                  className="avatar-img"
                                />
                              </div>
                            ))}
                        </div>
                        <div>
                          <b style={{ fontSize: "12px" }}>
                            {task.assignedTo.length > 0
                              ? task.assignedTo
                                  .map((person) => person.staffName)
                                  .join(", ")
                              : "No Approvers"}
                          </b>
                        </div>
                      </p>
                      <p className="approveStatus text-end">
                        <b>Approve Status:</b> <br></br>
                        <span
                          className={`custom-badge text-end ${task?.approveStatus?.toLowerCase()}`}
                        >
                          {task?.approveStatus}
                        </span>
                      </p>

                      <p className=" text-end approvedBy pe-0">
                        <b>Approve Person:</b>
                        <div className="avatars1 text-end ps-2  ">
                          {staffData
                            ?.filter((staff) =>
                              task.approvePerson?.some(
                                (approver) => approver._id === staff._id
                              )
                            )
                            .slice(0, 2) // show only first 3
                            .map((staff, i) => (
                              <div
                                key={`approve-${i}`}
                                style={{
                                  display: "inline-block",
                                  marginRight: "10px",
                                }}
                              >
                                <Image
                                  src={
                                    staff?.staffPhoto?.fileName
                                      ? apiUrlImage + staff.staffPhoto.fileName
                                      : apiUrlImage + "default.jpg"
                                  }
                                  roundedCircle
                                  className="avatar-img"
                                />
                              </div>
                            ))}

                          {/* Show "+N more" if count exceeds 3 */}
                          {task.approvePerson?.length > 2 && (
                            <div
                              style={{
                                verticalAlign: "middle",
                                background: "#ccc",
                                borderRadius: "50%",
                                width: "25px",
                                height: "25px",
                                textAlign: "center",
                                lineHeight: "26px",
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              +{task.approvePerson.length - 2}
                            </div>
                          )}
                        </div>
                        <div>
                          <b style={{ fontSize: "12px" }}>
                            {task?.approvePerson?.length > 0 ? (
                              <>
                                {task.approvePerson
                                  .slice(0, 2) // Only first 2 names
                                  .map((person, index) => (
                                    <span key={index}>
                                      {person.staffName}
                                      {index <
                                      task.approvePerson.slice(0, 2).length - 1
                                        ? ", "
                                        : ""}
                                    </span>
                                  ))}
                                {task.approvePerson.length > 2 && (
                                  <span>
                                    {" "}
                                    +{task.approvePerson.length - 2} more
                                  </span>
                                )}
                              </>
                            ) : (
                              "No Approvers"
                            )}
                          </b>
                        </div>
                      </p>
                    </div>
                  </Card>
                ))}
              </Offcanvas.Body>
            </Offcanvas>

            {permissions?.Task?.["Task Create"]?.Write && (
              <button
                className="taskBtn text-white"
                onClick={gotoCreateTask}
                style={{ backgroundColor: "#105cad" }}
              >
                &#x002B; Create Task
              </button>
            )}

            <img
              src={Map}
              alt="map"
              style={{ width: "30px", height: "30px" }}
              className="map-icon"
              onClick={gotoMapView}
            />
          </Col>
        </Row>
      </Container>
      {/* <Container> */}
      <Row className="taskRow2 pe-5 ps-4">
        <Col className="taskColumn">
          <Row className="status-container-row">
            <Col border className="border-3">
              <div className="status-container">
                <div className="status-item">
                  <span className="dot red"></span>
                  <span className="status-text">Over Due</span>
                  <span className="status-count">
                    {/* {filtere.filter(task => {
  const taskDeadline = new Date(task.deadline).setHours(0, 0, 0, 0);
  const today = new Date().setHours(0, 0, 0, 0);

  return (
    (task.taskStatus === "Open" || task.taskStatus === "Progress") &&
    taskDeadline < today
  );
}).length} */}
                    {filteredTasks.length}
                  </span>
                </div>
              </div>
            </Col>
            <Col>
              <div className="status-container1">
                <div className="status-item">
                  <span className="dot purplebox"></span>
                  <span className="status-text">Progress</span>
                  <span className="status-count">
                    {
                      filteredTasks.filter(
                        (task) => task.taskStatus?.toLowerCase() === "progress"
                      ).length
                    }
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <div className="underlineTask"></div>
          {filteredTasks === 0 ? (
            <div
              style={{ textAlign: "center", marginTop: "20px", color: "#555" }}
            >
              No overdue tasks.
            </div>
          ) : (
            filteredTasks.map((task, index) => (
              <Card
                key={index}
                // className="task-card-box p-0 mx-auto"
                className={`task-card-box p-0 mx-auto mt-5 ${getCardBgColor(
                  task.taskStatus,
                  task.approveStatus
                )}`}
                style={{ borderRadius: "20px" }}
              >
                <div className="mx-auto task-card-item mt-2  ">
                  <Row className="mb-2 ">
                    <Col className="pt-1 ">
                      {/* <Badge
                      bg={task.typeClass}
                      className="task-recovery"
                      onClick={gotomyTask}
                    >
                      {task.taskName}
                    </Badge> */}

                      <Badge
                        bg="jkjf"
                        className={`task-recovery taskname-padding  ${getTaskTypeColor(
                          task.taskName
                        )}`}
                        // onClick={gotomyTask}
                      >
                        {task.taskName.length > 15
                          ? `${task.taskName.substring(0, 15)}...`
                          : task.taskName}
                      </Badge>
                    </Col>
                    <Col className="text-end mb-0 pb-0">
                      <Badge
                        className="progress-main"
                        bg="progressbox"
                        onClick={gotomyTask}
                      >
                        <p
                          className={`progress-body ${getStatusColor(
                            task.taskStatus
                          )}`}
                        >
                          {["Hold", "No Response"].includes(task.taskStatus)
                            ? "Hold"
                            : task.taskStatus}
                        </p>
                      </Badge>
                    </Col>

                    {permissions?.Task?.["Edit Task"]?.Write && (
                      <span
                        className="dots mt-2"
                        onClick={() => {
                          togglePopup(task._id);
                        }}
                      >
                        ...
                      </span>
                    )}

                    {openPopup === task._id && (
                      <div className="task-popup-container p-0 m-0">
                        <button
                          className="task-close-btn"
                          onClick={settingPopupDots}
                        >
                          &times;
                        </button>
                        <div className="task-popup-content w-100 p-1 ms-2">
                          <div className="row d-flex justify-content-center align-items-center w-75">
                            <div className="col pt-1">
                              <HiPencil
                                onClick={() => gotoEditTask(task._id)}
                              />{" "}
                              <br />
                              {/* <MdDelete /> */}
                            </div>
                            <div
                              className="col pt-1 text-start"
                              onClick={() => gotoEditTask(task._id)}
                            >
                              Edit <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Row>

                  {/* <Card.Text className="task-description">
                  {task.description}
                </Card.Text> */}

                  <div
                    onClick={() => handleCardClick(task._id, task.assignedTo)}
                  >
                    <Card.Text
                      className={`task-description ${
                        !expandedIndexes[index] ? "line-clamp" : ""
                      }`}
                    >
                      {task.description || "No description"}
                    </Card.Text>

                    {task.description?.length > 100 && (
                      <span
                        onClick={() => toggleDescription(index)}
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          fontWeight: "500",
                          paddingTop: "-80px",
                        }}
                      >
                        {expandedIndexes[index] ? "Show less" : "Read more"}
                      </span>
                    )}

                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-5 mt-3">
                        <p className="assignedBy">
                          <b>
                            {" "}
                            Assigned By: {task.assignedBy?.staffName || "N/A"}
                          </b>
                          {/* <div>
                            {staffData
                              ?.filter(
                                (staff) => staff._id === task.assignedBy?.id
                              )
                              .map((staff, i) => (
                                <div
                                  key={`assignedBy-${i}`}
                                  style={{
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                >
                                  <Image
                                    src={
                                      staff?.staffPhoto?.fileName
                                        ? apiUrlImage +
                                          staff.staffPhoto.fileName
                                        : apiUrlImage + "default.jpg"
                                    }
                                    roundedCircle
                                    className="avatar-img"
                                  />
                                </div>
                              ))}
                          </div> */}
                        </p>
                        {/* <Badge className={`assignedBy ${getPriorityClass(task.taskPriority)}`}>
  {task.taskPriority}
</Badge> */}

                        <span
                          className={`assignedBy  taskpriority badge ${getPriorityClass(
                            task.taskPriority
                          )}`}
                        >
                          {task.taskPriority}
                        </span>
                      </div>

                      <div>
                        <p className="assignedTo">
                          <b>Assigned To:</b>
                          <div className="avatars mt-0">
                            {staffData
                              ?.filter((staff) =>
                                task.assignedTo?.some(
                                  (assigned) => assigned._id === staff._id
                                )
                              )
                              .map((staff, i) => (
                                <div
                                  key={i}
                                  style={{
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                >
                                  <Image
                                    src={
                                      staff?.staffPhoto?.fileName
                                        ? apiUrlImage +
                                          staff.staffPhoto.fileName
                                        : apiUrlImage + "default.jpg"
                                    }
                                    roundedCircle
                                    className="avatar-img"
                                  />
                                </div>
                              ))}
                          </div>
                          <div>
                            <b style={{ fontSize: "12px" }}>
                              <div className="mt-2">
                                {task.assignedTo?.length > 0 ? (
                                  <ul className="ps-3 mb-0">
                                    {task.assignedTo.map((person, index) => (
                                      <li
                                        key={index}
                                        style={{ fontSize: "14px" }}
                                      >
                                        {person.staffName}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <span style={{ fontSize: "14px" }}>
                                    No Approvers
                                  </span>
                                )}
                              </div>
                            </b>
                          </div>
                        </p>

                        <p className=" text-end approvedBy pe-0">
                          <b>Approve Person:</b>
                          <div className="avatars1 text-end ps-2  ">
                            {staffData
                              ?.filter((staff) =>
                                task.approvePerson?.some(
                                  (approver) => approver._id === staff._id
                                )
                              )
                              .slice(0, 2) // show only first 3
                              .map((staff, i) => (
                                <div
                                  key={`approve-${i}`}
                                  style={{
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                >
                                  <Image
                                    src={
                                      staff?.staffPhoto?.fileName
                                        ? apiUrlImage +
                                          staff.staffPhoto.fileName
                                        : apiUrlImage + "default.jpg"
                                    }
                                    roundedCircle
                                    className="avatar-img"
                                  />
                                </div>
                              ))}

                            {/* Show "+N more" if count exceeds 3 */}
                            {task.approvePerson?.length > 2 && (
                              <div
                                style={{
                                  verticalAlign: "middle",
                                  background: "#ccc",
                                  borderRadius: "50%",
                                  width: "25px",
                                  height: "25px",
                                  textAlign: "center",
                                  lineHeight: "26px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                +{task.approvePerson.length - 2}
                              </div>
                            )}
                          </div>
                          <div>
                            <b style={{ fontSize: "12px" }}>
                              {task?.approvePerson?.length > 0 ? (
                                <>
                                  {task.approvePerson
                                    .slice(0, 2) // Only first 2 names
                                    .map((person, index) => (
                                      <span key={index}>
                                        {person.staffName}
                                        {index <
                                        task.approvePerson.slice(0, 2).length -
                                          1
                                          ? ", "
                                          : ""}
                                      </span>
                                    ))}
                                  {task.approvePerson.length > 2 && (
                                    <span>
                                      {" "}
                                      +{task.approvePerson.length - 2} more
                                    </span>
                                  )}
                                </>
                              ) : (
                                "No Approvers"
                              )}
                            </b>
                          </div>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            ))
          )}
        </Col>
        <Col className="taskColumn">
          <Row className="status-container-row">
            <Col border className="border-3">
              <div className="status-container">
                <div className="status-item">
                  <span className="dot orangebox"></span>
                  <span className="status-text">Open</span>
                  <span className="status-count">
                    {/* {taskDetails.filter(task => {
  const taskDeadline = new Date(task.deadline).setHours(0, 0, 0, 0);
  const today = new Date().setHours(0, 0, 0, 0);

  return (
    task.taskStatus?.toLowerCase() === "open" &&
    taskDeadline >= today
  );

  
}).length} */}

                    {filteredTasksOpen.length}
                  </span>
                </div>
              </div>
            </Col>
            <Col>
              <div className="status-container1">
                <div className="status-item">
                  <span className="dot purplebox"></span>
                  <span className="status-text">Progress</span>
                  <span className="status-count">
                    {
                      filteredTasksOpen.filter((task) => {
                        const taskDeadline = new Date(task.deadline).setHours(
                          0,
                          0,
                          0,
                          0
                        );
                        const today = new Date().setHours(0, 0, 0, 0);

                        return (
                          task.taskStatus?.toLowerCase() === "progress" &&
                          taskDeadline >= today
                        );
                      }).length
                    }
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <div className="underlineTask_2"></div>

          {filteredTasksOpen.length === 0 ? (
            <div
              style={{ textAlign: "center", marginTop: "20px", color: "#555" }}
            >
              Task list is empty
            </div>
          ) : (
            filteredTasksOpen.map((task, index) => (
              <Card
                key={index}
                className={`task-card-box p-0 mx-auto mt-5 ${getCardBgColor(
                  task.taskStatus,
                  task.approveStatus
                )}`}
                style={{ borderRadius: "20px" }}
              >
                <div className="mx-auto task-card-item mt-2  ">
                  <Row className="mb-2 ">
                    <Col className="pt-1 ">
                      <Badge
                        bg="jkjf"
                        className={`task-recovery taskname-padding  ${getTaskTypeColor(
                          task.taskName
                        )}`}
                      >
                        {task.taskName}
                      </Badge>
                    </Col>
                    <Col className="text-end mb-0 pb-0">
                      <Badge
                        className="progress-main"
                        bg="progressbox"
                        onClick={gotomyTask}
                      >
                        <p
                          className={`progress-body ${getStatusColor(
                            task.taskStatus
                          )}`}
                        >
                          {["Hold", "No Response"].includes(task.taskStatus)
                            ? "Hold"
                            : task.taskStatus}
                        </p>
                      </Badge>
                    </Col>
                    {permissions?.Task?.["Edit Task"]?.Write && (
                      <span
                        className="dots mt-2"
                        onClick={() => togglePopup(task._id)}
                        style={{ zIndex: 1000 }}
                      >
                        ...
                      </span>
                    )}

                    {openPopup === task._id && (
                      <div className="task-popup-container p-0 m-0">
                        <button
                          className="task-close-btn"
                          onClick={settingPopupDots}
                        >
                          &times;
                        </button>
                        <div className="task-popup-content w-100 p-1 ms-2">
                          <div className="row d-flex justify-content-center align-items-center w-75">
                            <div className="col pt-1">
                              <HiPencil
                                onClick={() => gotoEditTask(task._id)}
                              />{" "}
                              <br />
                              {/* <MdDelete /> */}
                            </div>
                            <div
                              className="col pt-1 text-start"
                              onClick={() => gotoEditTask(task._id)}
                            >
                              Edit <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Row>
                  <div
                    onClick={() => handleCardClick(task._id, task.assignedTo)}
                  >
                    <Card.Text
                      className={`task-description ${
                        !expandedIndexes[index] ? "line-clamp" : ""
                      }`}
                    >
                      {task.description || "No description"}
                    </Card.Text>

                    {task.description?.length > 100 && (
                      <span
                        onClick={() => toggleDescription(index)}
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          fontWeight: "500",
                          paddingTop: "-80px",
                        }}
                      >
                        {expandedIndexes[index] ? "Show less" : "Read more"}
                      </span>
                    )}

                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-5 mt-3">
                        <p className="assignedBy">
                          <b>
                            {" "}
                            Assigned By: {task.assignedBy?.staffName || "N/A"}
                          </b>
                          {/* <div>
                            {staffData
                              ?.filter(
                                (staff) => staff._id === task.assignedBy?.id
                              )
                              .map((staff, i) => (
                                <div
                                  key={`assignedBy-${i}`}
                                  style={{
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                >
                                  <Image
                                    src={
                                      staff?.staffPhoto?.fileName
                                        ? apiUrlImage +
                                          staff.staffPhoto.fileName
                                        : apiUrlImage + "default.jpg"
                                    }
                                    roundedCircle
                                    className="avatar-img"
                                  />
                                </div>
                              ))}
                          </div> */}
                        </p>

                        <span
                          className={`assignedBy  taskpriority badge ${getPriorityClass(
                            task.taskPriority
                          )}`}
                        >
                          {task.taskPriority}
                        </span>
                      </div>

                      <div>
                        <p className="assignedTo">
                          <b>Assigned To:</b>
                          <div className="avatars mt-0">
                            {staffData
                              ?.filter((staff) =>
                                task.assignedTo?.some(
                                  (assigned) => assigned._id === staff._id
                                )
                              )
                              .map((staff, i) => (
                                <div
                                  key={i}
                                  style={{
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                >
                                  <Image
                                    src={
                                      staff?.staffPhoto?.fileName
                                        ? apiUrlImage +
                                          staff.staffPhoto.fileName
                                        : apiUrlImage + "default.jpg"
                                    }
                                    roundedCircle
                                    className="avatar-img"
                                  />
                                </div>
                              ))}
                          </div>
                          <div>
                            <b style={{ fontSize: "12px" }}>
                              <div className="mt-2">
                                {task.assignedTo?.length > 0 ? (
                                  <ul className="ps-3 mb-0">
                                    {task.assignedTo.map((person, index) => (
                                      <li
                                        key={index}
                                        style={{ fontSize: "14px" }}
                                      >
                                        {person.staffName}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <span style={{ fontSize: "14px" }}>
                                    No Approvers
                                  </span>
                                )}
                              </div>
                            </b>
                          </div>
                        </p>

                        <p className=" text-end approvedBy pe-0">
                          <b>Approve Person:</b>
                          <div className="avatars1 text-end ps-2  ">
                            {staffData
                              ?.filter((staff) =>
                                task.approvePerson?.some(
                                  (approver) => approver._id === staff._id
                                )
                              )
                              .slice(0, 2) // show only first 3
                              .map((staff, i) => (
                                <div
                                  key={`approve-${i}`}
                                  style={{
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                >
                                  <Image
                                    src={
                                      staff?.staffPhoto?.fileName
                                        ? apiUrlImage +
                                          staff.staffPhoto.fileName
                                        : apiUrlImage + "default.jpg"
                                    }
                                    roundedCircle
                                    className="avatar-img"
                                  />
                                </div>
                              ))}

                            {/* Show "+N more" if count exceeds 3 */}
                            {task.approvePerson?.length > 2 && (
                              <div
                                style={{
                                  verticalAlign: "middle",
                                  background: "#ccc",
                                  borderRadius: "50%",
                                  width: "25px",
                                  height: "25px",
                                  textAlign: "center",
                                  lineHeight: "26px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                +{task.approvePerson.length - 2}
                              </div>
                            )}
                          </div>

                          <div>
                            <b style={{ fontSize: "12px" }}>
                              {task?.approvePerson?.length > 0 ? (
                                <>
                                  {task.approvePerson
                                    .slice(0, 2) // Only first 2 names
                                    .map((person, index) => (
                                      <span key={index}>
                                        {person.staffName}
                                        {index <
                                        task.approvePerson.slice(0, 2).length -
                                          1
                                          ? ", "
                                          : ""}
                                      </span>
                                    ))}
                                  {task.approvePerson.length > 2 && (
                                    <span>
                                      {" "}
                                      +{task.approvePerson.length - 2} more
                                    </span>
                                  )}
                                </>
                              ) : (
                                "No Approvers"
                              )}
                            </b>
                          </div>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            ))
          )}
        </Col>
        <Col className="taskColumn">
          <Row className="status-container-row">
            <Col border className="border-3">
              <div className="status-container">
                <div className="status-item">
                  <span className="dot greenbox"></span>
                  <span className="status-text">Completed</span>
                  <span className="status-count">
                    {
                      taskDetails.filter(
                        (task) => task.taskStatus?.toLowerCase() === "completed"
                        // task.approveStatus?.toLowerCase() === "approved"
                      ).length
                    }
                  </span>
                </div>
              </div>
            </Col>
            <Col>
              <div className="status-container1">
                <div className="status-item">
                  <span className="status-text">Approve Pending</span>
                  <span className="status-count">
                    {
                      taskDetails.filter(
                        (task) =>
                          task.taskStatus?.toLowerCase() === "completed" &&
                          task.approveStatus?.toLowerCase() === "pending"
                      ).length
                    }
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <div className="underlineTask_3"></div>

          {filteredcompleted === 0 ? (
            <div
              style={{ textAlign: "center", marginTop: "20px", color: "#555" }}
            >
              No completed tasks
            </div>
          ) : (
            taskDetails
              .filter(
                (task) => ["completed"].includes(task.taskStatus?.toLowerCase())
                // task.approveStatus?.toLowerCase() === "approved"
              )
              .map((task, index) => (
                <Card
                  key={index}
                  // className="task-card-box p-0 mx-auto"
                  className={`task-card-box p-0 mx-auto mt-5 ${getCardBgColor(
                    task.taskStatus,
                    task.approveStatus
                  )}`}
                  style={{ borderRadius: "20px" }}
                >
                  <div className="mx-auto task-card-item mt-2  ">
                    <Row className="mb-2 ">
                      <Col className="pt-1 ">
                        {/* <Badge
                      bg={task.typeClass}
                      className="task-recovery"
                      onClick={gotomyTask}
                    >
                      {task.taskName}
                    </Badge> */}

                        <Badge
                          bg="jkjf"
                          className={`task-recovery taskname-padding  ${getTaskTypeColor(
                            task.taskName
                          )}`}
                          // onClick={gotomyTask}
                        >
                          {task.taskName}
                        </Badge>
                      </Col>
                      <Col className="text-end mb-0 pb-0">
                        <Badge
                          className="progress-main"
                          bg="progressbox"
                          onClick={gotomyTask}
                        >
                          <p
                            className={`progress-body ${getStatusColor(
                              task.taskStatus
                            )}`}
                          >
                            {["Hold", "No Response"].includes(task.taskStatus)
                              ? "Hold"
                              : task.taskStatus}
                          </p>
                        </Badge>
                      </Col>

                      {permissions?.Task?.["Edit Task"]?.Write && (
                        <span
                          className="dots mt-2"
                          onClick={() => {
                            togglePopup(task._id);
                          }}
                        >
                          ...
                        </span>
                      )}
                      {openPopup === task._id && (
                        <div className="task-popup-container p-0 m-0">
                          <button
                            className="task-close-btn"
                            onClick={settingPopupDots}
                          >
                            &times;
                          </button>
                          <div className="task-popup-content w-100 p-1 ms-2">
                            <div className="row d-flex justify-content-center align-items-center w-75">
                              <div className="col pt-1">
                                <HiPencil
                                  onClick={() => gotoEditTask(task._id)}
                                />{" "}
                                <br />
                                {/* <MdDelete /> */}
                              </div>
                              <div
                                className="col pt-1 text-start"
                                onClick={() => gotoEditTask(task._id)}
                              >
                                Edit <br />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Row>

                    {/* <Card.Text className="task-description">
                  {task.description}
                </Card.Text> */}

                    <div
                      onClick={() => {
                        const isApprovePerson = task.approvePerson?.some(
                          (p) => String(p._id) === String(userId)
                        );
                        const isAssignedPerson = task.assignedTo?.some(
                          (p) => String(p._id) === String(userId)
                        );

                        if (isApprovePerson || isAssignedPerson) {
                          handleByPersonClick(
                            task._id,
                            task.approvePerson,
                            task.assignedTo,
                            task.taskStatus
                          );
                        } else {
                          handleCardClick(task._id, task.assignedTo);
                        }
                      }}
                    >
                      <Card.Text
                        className={`task-description ${
                          !expandedIndexes[index] ? "line-clamp" : ""
                        }`}
                      >
                        {task.description || "No description"}
                      </Card.Text>

                      {task.description?.length > 100 && (
                        <span
                          onClick={() => toggleDescription(index)}
                          style={{
                            color: "blue",
                            cursor: "pointer",
                            fontWeight: "500",
                            paddingTop: "-80px",
                          }}
                        >
                          {expandedIndexes[index] ? "Show less" : "Read more"}
                        </span>
                      )}

                      <div>
                        <div className="d-flex justify-content-between align-items-center mb-5 mt-3">
                          <p className="assignedBy">
                            <b>
                              {" "}
                              Assigned By: {task.assignedBy?.staffName || "N/A"}
                            </b>
                            {/* <div>
                              {staffData
                                ?.filter(
                                  (staff) => staff._id === task.assignedBy?.id
                                )
                                .map((staff, i) => (
                                  <div
                                    key={`assignedBy-${i}`}
                                    style={{
                                      display: "inline-block",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <Image
                                      src={
                                        staff?.staffPhoto?.fileName
                                          ? apiUrlImage +
                                            staff.staffPhoto.fileName
                                          : apiUrlImage + "default.jpg"
                                      }
                                      roundedCircle
                                      className="avatar-img"
                                    />
                                  </div>
                                ))}
                            </div> */}
                          </p>
                          {/* <Badge className={`assignedBy ${getPriorityClass(task.taskPriority)}`}>
  {task.taskPriority}
</Badge> */}

                          <span
                            className={`assignedBy  taskpriority badge ${getPriorityClass(
                              task.taskPriority
                            )}`}
                          >
                            {task.taskPriority}
                          </span>
                        </div>

                        <div>
                          <Row className="task-assigned-approvedstatus">
                            <Col md={5} sm={5}>
                              <p className="assignedTo">
                                <b>Assigned To:</b>
                                <div className="avatars mt-0">
                                  {staffData
                                    ?.filter((staff) =>
                                      task.assignedTo?.some(
                                        (assigned) => assigned._id === staff._id
                                      )
                                    )
                                    .map((staff, i) => (
                                      <div
                                        key={i}
                                        style={{
                                          display: "inline-block",
                                          marginRight: "10px",
                                        }}
                                      >
                                        <Image
                                          src={
                                            staff?.staffPhoto?.fileName
                                              ? apiUrlImage +
                                                staff.staffPhoto.fileName
                                              : apiUrlImage + "default.jpg"
                                          }
                                          roundedCircle
                                          className="avatar-img"
                                        />
                                      </div>
                                    ))}
                                </div>
                                <div>
                                  <b style={{ fontSize: "12px" }}>
                                    <div className="mt-2">
                                      {task.assignedTo?.length > 0 ? (
                                        <ul className="ps-3 mb-0">
                                          {task.assignedTo.map(
                                            (person, index) => (
                                              <li
                                                key={index}
                                                style={{ fontSize: "14px" }}
                                              >
                                                {person.staffName}
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      ) : (
                                        <span style={{ fontSize: "14px" }}>
                                          No Approvers
                                        </span>
                                      )}
                                    </div>
                                  </b>
                                </div>
                              </p>
                            </Col>

                            <Col md={7} sm={7} className="text-end">
                              <p className="approveStatus">
                                <b>Approve Status:</b>
                              </p>

                              <span
                                className={`custom-badge  ${task?.approveStatus?.toLowerCase()}`}
                              >
                                {task?.approveStatus}
                              </span>
                            </Col>
                          </Row>

                          <p className=" text-end approvedBy pe-0">
                            <b>Approve Person:</b>
                            <div className="avatars1 text-end ps-2  ">
                              {staffData
                                ?.filter((staff) =>
                                  task.approvePerson?.some(
                                    (approver) => approver._id === staff._id
                                  )
                                )
                                .slice(0, 2) // show only first 3
                                .map((staff, i) => (
                                  <div
                                    key={`approve-${i}`}
                                    style={{
                                      display: "inline-block",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <Image
                                      src={
                                        staff?.staffPhoto?.fileName
                                          ? apiUrlImage +
                                            staff.staffPhoto.fileName
                                          : apiUrlImage + "default.jpg"
                                      }
                                      roundedCircle
                                      className="avatar-img"
                                    />
                                  </div>
                                ))}

                              {/* Show "+N more" if count exceeds 3 */}
                              {task.approvePerson?.length > 2 && (
                                <div
                                  style={{
                                    verticalAlign: "middle",
                                    background: "#ccc",
                                    borderRadius: "50%",
                                    width: "25px",
                                    height: "25px",
                                    textAlign: "center",
                                    lineHeight: "26px",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  +{task.approvePerson.length - 2}
                                </div>
                              )}
                            </div>
                            <div className="text-end">
                              <b style={{ fontSize: "12px" }}>
                                {task?.approvePerson?.length > 0 ? (
                                  <>
                                    {task.approvePerson
                                      .slice(0, 2) // Only first 2 names
                                      .map((person, index) => (
                                        <span key={index}>
                                          {person.staffName}
                                          {index <
                                          task.approvePerson.slice(0, 2)
                                            .length -
                                            1
                                            ? ", "
                                            : ""}
                                        </span>
                                      ))}
                                    {task.approvePerson.length > 2 && (
                                      <span>
                                        {" "}
                                        +{task.approvePerson.length - 2} more
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  "No Approvers"
                                )}
                              </b>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              ))
          )}
        </Col>
      </Row>

      {/* </Container> */}
    </div>
  );
}
